<style>
	.bg555 {
		background-color: #fff;width:100%; 
	}
 
 
.draw-enter-active, .draw-leave-active {
     transition: opacity 0.2s;
}
.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
     opacity: 0;
}
.top_area{width:100%;height:4vw;position:fixed;top:1vw;left:0; }
.top_area img{display:block;float:left;height:4vw; }
.tabbar8{width:84vw;height:4vw;background:url(../../assets/images/tabbar_bg.png) center center; border-radius:.5vw;
float:left;margin-left:2.5vw;background-size:105% 105%;  }
.tabbar8 span{display:block;float:left;line-height:4vw;font-size:1.4vw;}
.tabbar8 span.pos{ padding:0 1vw;}
.tabbar8 span.floder{ color:#666;}
 
.tabbar8 span.rights{background:url(../../assets/images/right.png) no-repeat;width:2vw;
height:4vw;background-position:center center;background-size:2vw;} 
  


.sj_list{width:84vw;margin-left:7vw;margin-top:1vw;height:8vw;border:#e5e5e5 solid 1px;}
.sj_left{width:40vw;height:100%; position:relative;float:left;}
.sj_left input{ width: 1.4vw;height:1.4vw;border-radius:.5vw;display:block;float:left;-webkit-border-radius:.5vw;position:absolute;left:1vw;top:1vw;}
.sj_left img{display:block;position:absolute;top:1vw;left:3vw;width:2vw;}
.sj_left_title{width:50vw;height:2vw;position:absolute;left:5vw;top:1vw;}
.sj_left_title span{display:block;float:left;line-height:2vw;}
.sj_left_title span.t1{font-size:1.2vw;color:#0F7A3E;}
.sj_left_title span.t2{font-size:1vw;padding-left:.5vw;color:#999;}
.sj_left span.fl{position:absolute;display:block;top:3.5vw;left:5vw;font-size:1vw;color:#999;border:#ddd solid 1px;height:2vw;line-height:2vw;padding:0 .5vw;
    border-radius:.5vw;}
.sj_left span.fl55{position:absolute;display:block;top:5.5vw;left:5vw;font-size:1vw;color:#999;height:2vw;line-height:2vw;padding:0 .5vw;}
	
.sj_middle{width:10vw;height:100%;border-right:#ddd solid 1px;float:right;box-sizing:border-box;border-left:#ddd solid 1px;}
.sj_middle span{display:block;height:2.65vw;line-height:2.65vw;text-align:left;border-bottom:#ddd solid 1px;width:8vw;padding:0 1vw;font-size:1vw;
 color:#333;}
 
.sj_right{width:14vw;height:100%; float:right;box-sizing:border-box;}
.sj_right span{display:block;height:2.65vw;line-height:2.65vw;text-align:left;border-bottom:#ddd solid 1px;width:12vw;padding:0 1vw;font-size:1vw;
 color:#333;}
.sj_right span.mn2{color:#0F7A3E;}
.sj_right span.mn3{color:#f00;}
.sj_fresh{width:10vw;height:100%;border-left:#ddd solid 1px;box-sizing:border-box;float:right;}
.sj_fresh img{display:block;margin:0 auto;width:2.5vw;margin-top:2vw;}
.sj_fresh span{display:block;width:100%;text-align:center;line-height:3vw;color:#3465ff;font-size:1vw;}

.pages{margin:0 auto;padding:0;overflow:hidden;width:84vw;height:4vw; margin-top:2vw;} 
.pre{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;}
.pre img{width:2vw;margin-top:.25vw;margin-left:.2vw;}
 
.next{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;margin-left:1vw;}
.next img{width:2vw;margin-top:.25vw;margin-left:.25vw;}

.submits6{width:22vw;height:4vw;border-radius:.5vw;float:right; }
.submits6 button{outline:none;border:0;font-size:1.2vw;display:block;height:4vw;line-height:4vw;width:10vw;color:#fff;border-radius:.5vw;float:right;}
.submits6 button.ck{outline:none;border:#ddd solid 1px;font-size:1.2vw;display:block;height:4vw;line-height:4vw; color:#333;border-radius:.5vw;background:none;
float:left;}
.submits6 button.zong{background:#3268ff;}
.send_result{margin-top:7vw;}
</style>
 
<template>
	<div class="bg555">
	      

		
	     <u_center  ></u_center>
	     <div class="top_area">
		    <img @click="home()" src="../../assets/images/home_icon.png">
			<div class="tabbar8">
			   <span class="pos">您的当前位置:</span>
			   <span class="floder">发送短信通知</span>
			   <span class="rights"></span>
			   <span class="floder">选择短信模板</span>
			   <span class="rights"></span>
			   <span class="floder">导入数据表</span>
			   <span class="rights"></span>
			   <span class="floder">查看发送结果</span>
			</div>
		 </div>
		  
		 <div class="send_result">  
		 <div class="sj_list " v-for="item in list">
             <div class="sj_left">
			     
				<img src="../../assets/images/excel.png">
				<div class="sj_left_title">
					<span class="t1">{{item.name}}</span>
					<span class="t2">{{item.time|formatDate}}</span>
				</div>
				<span class="fl">{{item.year}}年-{{item.zs_category}}-{{item.grade}}-{{item.category}}-{{item.area}}-{{item.type}}</span>
				<span class="fl55">发送时间:{{item.time|formatDate}}</span>
			 </div>
			 <div class="sj_fresh" @click="refresh()">
			    <img src="../../assets/images/fresh.svg">
				<span >刷新数据</span>
			 </div>
             <div class="sj_right">
			      <span class="mn1">{{item.success+item.failed}}</span>
				  <span class="mn2">{{item.success}}</span>
				  <span class="mn3" style="border-bottom:0;">{{item.failed}}</span>
			 </div>
			 <div class="sj_middle">
			      <span class="m1">总发送短信</span>
				  <span class="m2">发送成功</span>
				  <span class="m3" style="border-bottom:0;">发送失败</span>
			 </div>
         </div>
         </div>	 
         <div class="pages">
		   <div v-if="total_page>1">
				<div class="pre" @click="pre_page()"   v-if="page>1">
				   <img src="../../assets/images/pre2.png">
				</div>
				<div class="pre"   v-else>
				   <img src="../../assets/images/pre1.png">
				</div>
				
				<div class="next" @click="next_page()" v-if="page<total_page">
				   <img src="../../assets/images/next1.png">
				</div>
				<div class="next"  v-else>
				   <img src="../../assets/images/next2.png">
				</div>
			</div>
			<div class="submits6">
			   
		        <button class="zong" @click="daochu()">导出总失败数据</button>
				 <button class="ck" @click="look_his()">查看历史发送数据</button>
		     </div>
		 </div>
	</div>
</template>
<script>
import u_center from '@/components/u_center.vue'; 
import Progress from "easy-circular-progress";
	export default {
	    components: {
		  u_center,
		  Progress
	    },
		data() {
			return {
				 list:[],			   
				 all_check:false,
				 year:2021,
				 year_list:[{id:1,year:2021},{id:2,year:2022}],
				 xiala1:false,
				 xiala2:false,
				 xiala3:false,
				 xiala4:false,
				 xiala5:false,
				 leibie:"统招",
				 zhao_list:[{id:1,zhao:'统招'},{id:2,zhao:'单招'}],
				 pici:'本科批',
				 pici_list:[{id:1,pi:'本科批'},{id:2,pi:'专科批'}],
				 dalei:"普通类",
				 lei_list:[{id:1,lei:'普通类'},{id:2,lei:'财经类'},{id:3,lei:'艺术类'},{id:4,lei:'计算机类'}],
				 area:"全国",
				 area_list:[{id:0,area:'全国'},{id:2,area:'北京'},{id:3,area:'天津'},{id:4,area:'上海'},{id:5,area:'河北'},{id:6,area:'河南'}],
				 progress_show:true,
				 onkey_show:false,
				 safe_show:false,
				 mode:2,
				 task_id:"",
				 page:1,
				 total_page:1
				 
			}
		},filters: {
				formatDate: function(value) {
					var date = new Date();
					 date.setTime(value*1000);
					var month = date.getMonth() + 1;
					var hours = date.getHours();
					if (hours < 10)
						hours = "0" + hours;
					var minutes = date.getMinutes();
					if (minutes < 10)
						minutes = "0" + minutes;
					var time = date.getFullYear() + "-" + month + "-" + date.getDate() +
						" " + hours + ":" + minutes;
					return time;
				}
			},
		mounted() {
		    let self=this;
		    this.task_id = this.$utils.getUrlKey('task_id');
		      var token= localStorage.getItem("token");
			  if(!token){
					 self.$router.push("/");  
			  }else{
			      self.token=token;
				  self.get_task_list();
			  }  
		},
		methods: {
		    home(){
			  this.$router.push("/");  
			},
			look_his(){
			  this.task_id="";
			  this.get_task_list();
			},
			refresh(){
			   this.get_task_list();
			   this.$loading('刷新中...');
			   let self=this;
			                 setTimeout(function(){
								        self.$loading.close();
										 self.$toast.center('刷新成功');
					         },1000);
	 
			},
			 pre_page(){
		     if(this.page>1){
			    this.page=this.page-1;
				this.get_task_list();
			 }
		   },next_page(){
		      if(this.page<this.total_page){
			    this.page=this.page+1;
				this.get_task_list();
			  }
		   },daochu(){
		        this.$toast.center('暂无失败数据');
		   },
		   get_task_list(){	        
		      let self=this;
		      axios.post(this.$api+'/message/get_task_list', {
					   token:self.token,
					   task_id:self.task_id,
					   page:self.page
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					 self.list=data.data.list;
                     self.total_page=data.data.total_page;					 
				  } 
		      }).catch(function (error) {
			         
		      });
		   },
		    check(id,val){
			    var new_list=[];                   
				this.list.forEach(function(obj,index){
					new_list[index]=obj;
					if( obj.id==id){
						new_list[index].on=val;
					} 
				});
			    this.list=new_list;
				console.log(this.list)
			},all(val){
			    var new_list=[];                   
				this.list.forEach(function(obj,index){
					new_list[index]=obj;
					new_list[index].on=val; 
				});
			    this.list=new_list;
			},xiala(id){
			  if(id==1){
			     this.xiala1=!this.xiala1;this.xiala2=false;this.xiala3=false;this.xiala4=false;this.xiala5=false;
			  }else if(id==2){
			     this.xiala2=!this.xiala2;this.xiala1=false;this.xiala3=false;this.xiala4=false;this.xiala5=false;
			  }else if(id==3){
			     this.xiala3=!this.xiala3;this.xiala1=false;this.xiala2=false;this.xiala4=false;this.xiala5=false;
			  }else if(id==4){
			     this.xiala4=!this.xiala4;this.xiala1=false;this.xiala2=false;this.xiala3=false;this.xiala5=false;
			  }else if(id==5){
			     this.xiala5=!this.xiala5;this.xiala1=false;this.xiala2=false;this.xiala3=false;this.xiala4=false;
			  }
			},select_year(year){
			  this.year=year;
			  this.xiala1=false;
			},select_zhao(zhao){
			  this.leibie=zhao;
			  this.xiala2=false;
			},select_pi(pi){
			  this.pici=pi;
			  this.xiala3=false;
			},select_lei(lei){
			  this.dalei=lei;
			  this.xiala4=false;
			},select_area(area){
			  this.area=area;
			  this.xiala5=false;
			}
		     
		},watch:{
			 all_check(){
			   if(this.all_check==true){
			     this.all(1)
			   }else{
			     this.all(0)
			   }
			 }
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/sms/send_result.vue